import service from '../request/index'

// 短信验证码登录/注册接口
export function getSmsLogin(data) {
  return service({
    url: '/login/smsLogin',
    method: "post",
    data
  })
}
// 短信验证码接口
export function getSendSmsCode(data) {
  return service({
    url: '/login/sendSmsCode',
    method: "post",
    data
  })
}
// 微信扫码授权接口
export function getWechatLogin(data) {
  return service({
    url: '/login/wechatLogin',
    method: "post",
    data
  })
}
// 支付宝扫码授权接口
export function getAlipayLogin(data) {
  return service({
    url: '/login/alipayLogin',
    method: "post",
    data
  })
}
// 支付宝扫码授权接口
export function getAlipayH5Login(data) {
  return service({
    url: '/loginh5/alipayLogin',
    method: "post",
    data
  })
}

// 扫码登录绑定手机号
export function getBindPhone(data) {
  return service({
    url: '/login/bindPhone',
    method: "post",
    data
  })
}
// 图形验证码接口
export function getCaptcha(data) {
  return service({
    url: '/Login/captcha',
    method: "get",
    params: data
  })
}
// 支付宝扫码登录url获取
export function getGenerateLoginData(data) {
  return service({
    url: '/login/generateLoginData',
    method: "post",
    data
  })
}
// 获取logo、隐私政策、电话、二维码等等
export function getConfigdata(data) {
  return service({
    url: '/index/Configdata',
    method: "get",
    params: data
  })
}
// 个人信息
export function getUserInfos(data) {
  return service({
    url: '/User/getUserInfo',
    method: "get",
    params: data
  })
}
// 首页banner
export function getBanner(data) {
  return service({
    url: '/index/banner',
    method: "get",
    params: data
  })
}
// 量表测评
export function getAssessment(data) {
  return service({
    url: '/index/assessment',
    method: "get",
    params: data
  })
}
// 量表分类
export function getScaleCategory(data) {
  return service({
    url: '/index/scalecategory',
    method: "get",
    params: data
  })
}
// 咨询师列表
export function getConsultant(data) {
  return service({
    url: '/index/consultant',
    method: "get",
    params: data
  })
}
// 系统字典/咨询师分类
export function getDictData(data) {
  return service({
    url: '/index/dictdata',
    method: "get",
    params: data
  })
}
// 咨询师详情
export function getConsultantInfo(data) {
  return service({
    url: '/index/consultantinfo',
    method: "get",
    params: data
  })
}
// 咨询师用户评价
export function getIndexEvaluatelist(data) {
  return service({
    url: '/index/evaluatelist',
    method: "get",
    params: data
  })
}
// 文章分类
export function getItemCate(data) {
  return service({
    url: '/index/itemcate',
    method: "get",
    params: data
  })
}
// 文章列表
export function getArticle(data) {
  return service({
    url: '/index/article',
    method: "get",
    params: data
  })
}
// 文章详情
export function getArticleInfo(data) {
  return service({
    url: '/index/articleinfo',
    method: "get",
    params: data
  })
}
// 友情链接
export function getLink(data) {
  return service({
    url: '/index/link',
    method: "get",
    params: data
  })
}
// 底部菜单导航
export function getBottommenu(data) {
  return service({
    url: '/index/bottommenu',
    method: "get",
    params: data
  })
}
// 私信列表
export function getUserconsultantchatlist(data) {
  return service({
    url: '/User/userconsultantchatlist',
    method: "get",
    params: data
  })
}
// 一键已读
export function getReadAllMessages(data) {
  return service({
    url: '/User/readAllMessages',
    method: "get",
    params: data
  })
}
// 用户发送消息
export function getSendMessage(data) {
  return service({
    url: '/User/sendMessage',
    method: "post",
    data
  })
}
// 私信明细
export function getUserconsultantchatlistinfo(data) {
  return service({
    url: '/User/userconsultantchatlistinfo',
    method: "get",
    params: data
  })
}
// 已读私信
export function getUpdateReadStatus(data) {
  return service({
    url: '/User/updateReadStatus',
    method: "post",
    data
  })
}
// 问题列表
export function getQuestionsAnswers(data) {
  return service({
    url: '/User/questions_answers',
    method: "get",
    params: data
  })
}
// 问题回答
export function getQuestionsAnswersInfo(data) {
  return service({
    url: '/User/questions_answers_info',
    method: "get",
    params: data
  })
}
// 发布问答
export function getPostQuestion(data) {
  return service({
    url: '/User/postQuestion',
    method: "post",
    data
  })
}
// 预约订单
export function getConsultationOrder(data) {
  return service({
    url: '/User/consultation_order',
    method: "get",
    params: data
  })
}
// 预约订单确认
export function getConfirm(data) {
  return service({
    url: '/User/confirm',
    method: "post",
    data
  })
}
// 提交用户评价
export function getPjsubmit(data) {
  return service({
    url: '/User/pjsubmit',
    method: "post",
    data
  })
}
// 会员订单
export function getNewMemberOrder(data) {
  return service({
    url: '/User/NewMemberOrder',
    method: "get",
    params: data
  })
}
// 测试剩余次数
export function getUserScaleRemaining(data) {
  return service({
    url: '/User/user_scale_remaining',
    method: "get",
    params: data
  })
}
// 测试记录
export function getScaletestrecord(data) {
  return service({
    url: '/User/scaletestrecord',
    method: "get",
    params: data
  })
}
// 提交入驻申请
export function getSubmitApplication(data) {
  return service({
    url: '/User/submitApplication',
    method: "post",
    data
  })
}
// 获取当前用户的申请状态
export function getApplicationStatus(data) {
  return service({
    url: '/User/getApplicationStatus',
    method: "get",
    params: data
  })
}
// 更新入驻申请信息
export function getUpdateApplication(data) {
  return service({
    url: '/User/updateApplication',
    method: "post",
    data
  })
}
// 修改手机号
export function getUpdatePhone(data) {
  return service({
    url: '/User/updatePhone',
    method: "post",
    data
  })
}
// 修改昵称
export function getUpdateNickname(data) {
  return service({
    url: '/User/updateNickname',
    method: "post",
    data
  })
}
// 修改头像
export function getUpdateAvatar(data) {
  return service({
    url: '/User/updateAvatar',
    method: "post",
    data
  })
}

//下面咨询师相关接口
// 咨询师基本信息
export function getConsultantInfoConsultant(data) {
  return service({
    url: '/Consultant/getConsultantInfo',
    method: "get",
    params: data
  })
}
// 咨询师修改接单状态
export function getUpdateWorkStatus(data) {
  return service({
    url: '/Consultant/updateWorkStatus',
    method: "get",
    params: data
  })
}
// 接单时间修改
export function getUpdateAvailableTime(data) {
  return service({
    url: '/Consultant/updateAvailableTime',
    method: "get",
    params: data
  })
}
// 咨询师个人评价
export function getEvaluatelist(data) {
  return service({
    url: '/Consultant/evaluatelist',
    method: "get",
    params: data
  })
}
// 咨询师预约订单
export function getConsultantOrder(data) {
  return service({
    url: '/Consultant/consultation_order',
    method: "get",
    params: data
  })
}
// 完成咨询
export function getConsultantConfirm(data) {
  return service({
    url: '/Consultant/confirm',
    method: "post",
    data
  })
}
// 私信列表
export function getConsultantUserconsultantchatlist(data) {
  return service({
    url: '/Consultant/userconsultantchatlist',
    method: "get",
    params: data
  })
}
// 一键已读
export function getConsultantReadAllMessages(data) {
  return service({
    url: '/Consultant/readAllMessages',
    method: "get",
    params: data
  })
}
// 咨询师发送消息
export function getConsultantSendMessage(data) {
  return service({
    url: '/Consultant/sendMessage',
    method: "post",
    data
  })
}
// 已读私信
export function getConsultantUpdateReadStatus(data) {
  return service({
    url: '/Consultant/updateReadStatus',
    method: "post",
    data
  })
}
// 拉黑用户
export function getBlockConsultant(data) {
  return service({
    url: '/Consultant/blockConsultant',
    method: "post",
    data
  })
}
// 黑名单
export function getMyBlacklist(data) {
  return service({
    url: '/Consultant/myBlacklist',
    method: "get",
    params: data
  })
}
// 取消黑名单
export function getUnblockConsultant(data) {
  return service({
    url: '/Consultant/unblockConsultant',
    method: "post",
    data
  })
}
// 问答大厅全部回答
export function getConsultantQuestionsAnswers(data) {
  return service({
    url: '/Consultant/questions_answers',
    method: "get",
    params: data
  })
}
// 问答大厅我的回答
export function getConsultantMyAnswers(data) {
  return service({
    url: '/Consultant/myAnswers',
    method: "get",
    params: data
  })
}
// 咨询师回答问题接口
export function getAnswerQuestion(data) {
  return service({
    url: '/Consultant/answerQuestion',
    method: "post",
    data
  })
}
// 咨询师提交接口
export function getConsultantSubmitApplication(data) {
  return service({
    url: '/Consultant/submitApplication',
    method: "post",
    data
  })
}
// 审核记录
export function getConsultantpricereview(data) {
  return service({
    url: '/Consultant/consultantpricereview',
    method: "get",
    params: data
  })
}
// 价格设置的状态
export function getSubscriptionStatus(data) {
  return service({
    url: '/Consultant/subscriptionStatus',
    method: "post",
    data
  })
}
export function getAdjustapply(data) {
  return service({
    url: '/Consultant/adjustapply',
    method: "post",
    data
  })
}
// 唯一标识 
export function generateAssessmentUrl(data) {
  return service({
    url: '/ScaleAssessment/generateAssessmentUrl',
    method: "post",
    data
  })
}
// 平台问答列表
export function getQuestionsAnswersIndex(data) {
  return service({
    url: '/index/questions_answers',
    method: "get",
    params: data
  })
}
// 平台问答详情
export function getQuestionsAnswersIndexInfo(data) {
  return service({
    url: '/index/questions_answers_info',
    method: "get",
    params: data
  })
}
// 选择您的会员方案
export function getLevelListUser(data) {
  return service({
    url: '/user/getLevelList',
    method: "get",
    params: data
  })
}
// 立即开通会员
export function getMemberCreateOrder(data) {
  return service({
    url: '/Member/createOrder',
    method: "post",
    data
  })
}
// 预约咨询
export function getCreateAndPay(data) {
  return service({
    url: '/Consultation/createAndPay',
    method: "post",
    data
  })
}
// 导出全部测试记录
export function getrecordExportExcel(data) {
  return service({
    url: '/user/record_exportExcel',
    method: "post",
    data
  })
}
// 支付
export function getCreateScaleOrder(data) {
  return service({
    url: '/ScaleAssessment/createScaleOrder',
    method: "post",
    data
  })
}
// 单次购买
export function getScaleOrder(data) {
  return service({
    url: '/ScaleAssessment/getScaleOrder',
    method: "post",
    data
  })
}

// 会员开通
export function getMemberOrder(data) {
  return service({
    url: '/Member/getMemberOrder',
    method: "post",
    data
  })
}

// 预约咨询师查询
export function getConsultationOrderState(data) {
  return service({
    url: '/Consultation/getConsultationOrder',
    method: "post",
    data
  })
}

// 获取openid
export function getOpenid(data) {
  return service({
    url: '/login/wx_openid',
    method: "post",
    data
  })
}

// wx-JS-SDK
export function getwxConfig(data) {
  return service({
    url: '/login/wx_config',
    method: "post",
    data
  })
}
// 咨询师查看量表测试记录
export function getScaletestrecordUser(data) {
  return service({
    url: '/User/scaletestrecord_user?page=' + data.page + '&limit=' + data.limit + '&user_id=' + data.user_id,
    method: "get",
  })
}
// 公众号授权登录
export function getwxOfficialLogin(data) {
  return service({
    url: '/login/wx_official_login',
    method: "post",
    data
  })
}
// 手机端支付宝授权登录
export function getAuthData(data) {
  return service({
    url: '/login/getAuthData',
    method: "post",
    data
  })
}
// getH5Pay
export function getH5Pay(data) {
  return service({
    url: '/loginh5/getAuthData',
    method: "post",
    data
  })
}
// export function homeInfo(data) {
//   return service({
//     url: '/index/banner',
//     method: "post",
//     data
//   })
// }